"use client"

import React from 'react';
import {Segment} from "@/types/Segments";
import Image from "next/image";
import {Path} from "@/types/Paths";
import {Place} from "@/types/Places";

export default function FeaturedImage(props: {
  width: number,
  height: number,
  data?: Segment | Path | Place,
  className?: string,
  bg?: string,
  src?: string,
  fg?: string
}) {
  const {src, className = "", bg = 'DDDDDD', fg = 'FFFFFF', width, height, data} = props
  if (src) {
    return <Image className={className} unoptimized width={width} height={height} src={src} alt={'thumb'}/>
  }
  const feat = data?.images?.at(0)
  if (feat) return <Image className={className} unoptimized width={width} height={height} src={feat.url} alt={'thumb'}/>
  return <Image className={className} unoptimized width={width} height={height}
                src={`https://placehold.co/${width}x${height}/${bg}/${fg}`} alt={'thumb'}/>
}
